import { render, staticRenderFns } from "./AbilityInput.vue?vue&type=template&id=6cbfc771&"
import script from "./AbilityInput.vue?vue&type=script&lang=js&"
export * from "./AbilityInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports